import React from 'react';
import { Card } from 'antd';
import PaginatedTable, { PaginatedTableProps } from '../../../../common/PaginatedTable';
import { Tenant } from '../types/tenant.types';

const SysAdminTenantTable = (props: PaginatedTableProps<Tenant>) => {
  return (
    <Card className="shadow-lg">
      <PaginatedTable<Tenant>
        data={props.data}
        columns={props.columns}
        loading={props.loading}
        pagination={props.pagination}
        rowKey={props.rowKey}
        onPageChange={props.onPageChange}
        onPageSizeChange={props.onPageSizeChange}
        className={props.className}
        showSizeChanger={props.showSizeChanger}
        tableProps={props.tableProps}
        showSearchBar={props.showSearchBar}
        onSearchChange={props.onSearchChange}
        showFilters={props.showFilters}
        availableFilters={props.availableFilters}
        onFilterChange={props.onFilterChange}
        sortField={props.sortField}
        sortOrder={props.sortOrder}
      />
    </Card>
  );
};

// Memoize the component to prevent unnecessary re-renders
export default React.memo(SysAdminTenantTable);
